import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { SentryLoggingMonitor } from '@src/app/services/logging/sentry-logging-monitor/sentry-logging-monitor';
import { EnvironmentConfig } from '@src/app/configs/environment.config';

/* tslint:disable:max-classes-per-file */

/**
 * Service that handles logging of various things in the app.
 * In the constructor a monitor is bind which processes the errors.
 * Note, only one monitor can be registered at a time.
 * See https://www.npmjs.com/package/ngx-logger.
 */
@Injectable()
export class LoggingService {
  constructor(
    protected readonly _ENV_CONFIG: EnvironmentConfig,
    private logger: NGXLogger
  ) {
    if (_ENV_CONFIG.logging.serverLoggingEnabled) {
      this.logger.registerMonitor(new SentryLoggingMonitor(_ENV_CONFIG));
    }
  }

  // The functions below handle the several error cases.

  public trace(message: string, additional: string[] = []): void {
    this.logger.trace(message, additional);
  }

  public debug(message: string, additional: string[] = []): void {
    this.logger.debug(message, additional);
  }

  public info(message: string, additional: string[] = []): void {
    this.logger.info(message, additional);
  }

  public log(message: string, additional: string[] = []): void {
    this.logger.log(message, additional);
  }

  public warn(message: string, additional: string[] = []): void {
    this.logger.warn(message, additional);
  }

  public error(error: Error, additional: string[] = []): void {
    this.logger.error(error, additional);
  }

  public fatal(error: Error = null, additional: string[] = []): void {
    this.logger.fatal(error, additional);
  }
}
